import React from "react";
import Header from "../_components/common/Header";
import ReviewAccuracyTrackingUI from "../_components/UI/ReviewAccuracyTrackingUI";

const ReviewAccuracyTracking = () => {
  return (
    <div className="page-main">
      <Header name={["Review & Accuracy Tracking"]} />
      <ReviewAccuracyTrackingUI />
    </div>
  );
};

export default ReviewAccuracyTracking;
